<template>
  <div class="container" id="slot-engine-sect">
    <div v-if="this.$route.name === 'AboutUs'">
      <div class="heading">
        <h3 class="title-section text-center">Our Values</h3>
        <h4 class="title-section text-center">Why Us?</h4>
      </div>
    </div>
    <div class="page_about_us_info" v-if="this.$route.name === 'AboutUs'">
      <div class="value" v-for="(item, index) in values" :key="index">
        <div class="value__icon">
          <img
            loading="lazy"
            :src="this.publicPath + item.icon"
            :alt="item.alt"
          />
        </div>
        <div class="value__heading">{{ item.heading }}</div>
        <div class="value__content">
          <div class="content">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <div class="row" v-if="this.$route.name === 'OurSolutions_Page'">
      <div class="col-md-12 text-center">
        <h1 class="the-builder">Slot Builder</h1>
        <div class="builder-information">
          <p>
            Being always innovative while focusing on the day to day can be
            challenge, have unique content doesn't need to be expensive. The Ear
            Slot Engine,created for you the framework to do just that. Simply
            design the graphic part of your future game and upload them in the
            tool. Easy to configure the number of reels, adjust the animation,
            select the lines & win patterns, choose the RTP, adjust volatility
            and also Jackpots if you want and your game is ready
          </p>
        </div>
      </div>
      <!-- col-md-3 col-sm-6 col-xs-12 originale -->
      <div
        class="col-md-3 col-sm-6 col-xs-12 col-6 text-center builder-img-features"
        v-for="builderItem in builderItems"
        :key="builderItem.alt"
      >
        <img
          class="fade-in-fwd"
          loading="eager"
          :src="this.publicPath + builderItem.icon"
          :alt="builderItem.alt"
        />
        <p>{{ builderItem.text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhyUs",
  data() {
    return {
      lang: localStorage.getItem("language") || "en",
      publicPath: process.env.VUE_APP_PUBLIC_PATH ?? "/",

      values: [
        {
          icon: "assets/images/megafono.png",
          alt: "Engaging Marketing feature",
          heading: "Engaging Marketing feature",
          content:
            "Bonuses that can easily adapt to your marketing plan, be creative with our 10+ triggers for bonus activation.",
        },
        {
          icon: "assets/images/coppa.png",
          alt: "Build your own tournament",
          heading: "Build your own tournament",
          content:
            "Create engaging tournaments with standard and complex point accumulation, to always keep players loyal to your tournaments.",
        },
        {
          icon: "assets/images/dollaro2.png",
          alt: "Slot Builder",
          heading: "Slot Builder",
          content:
            "The most comprehensive and unique slot builder in the industry, easy to use, with multiple customization options.",
        },
        {
          icon: "assets/images/laptop.png",
          alt: "Tech",
          heading: "Tech",
          content: "Our superior technology allows our partners to thrive.",
        },
      ],
      builderItems: [
        {
          icon: "assets/images/uploadImage.png",
          alt: "Upload Graphics",
          text: "Upload Graphics",
        },
        {
          icon: "assets/images/numberReel.png",
          alt: "Select Numbers Of Reels/Lines",
          text: "Select Numbers Of Reels/Lines",
        },
        {
          icon: "assets/images/animation.png",
          alt: "Upload Animations",
          text: "Upload Animations",
        },
        {
          icon: "assets/images/volatility.png",
          alt: "Adjust Volatility",
          text: "Adjust Volatility",
        },
        {
          icon: "assets/images/rtp.png",
          alt: "Choose The RTP",
          text: "Choose The RTP",
        },
        {
          icon: "assets/images/lobby.png",
          alt: "In-Game Lobby",
          text: "In-Game Lobby",
        },
        {
          icon: "assets/images/multigame.png",
          alt: "Multigame Available",
          text: "Multigame Available",
        },
        {
          icon: "assets/images/cronologia.png",
          alt: "Round History",
          text: "Round History",
        },
        {
          icon: "assets/images/message.png",
          alt: "Custom Messages in Game",
          text: "Custom Messages in Game",
        },
        {
          icon: "assets/images/sound_fx.png",
          alt: "Add Music and Sound FX",
          text: "Add Music and Sound FX",
        },
        {
          icon: "assets/images/free_spins.png",
          alt: "Buy Free Spin Option",
          text: "Buy Free Spin Option",
        },
        {
          icon: "assets/images/multi-lingua.png",
          alt: "All Languages Available",
          text: "All Languages Available",
        },
        {
          icon: "assets/images/crypto.png",
          alt: "Fiat & Crypto Currency Supported",
          text: "Fiat & Crypto Currency Supported",
        },
        {
          icon: "assets/images/turbo.png",
          alt: "Turbo and Gamble Option",
          text: "Turbo and Gamble Option",
        },
      ],
    };
  },
  created() {
    document.body.style.fontFamily = "Poppins, sans-serif";
  },
};
</script>

<style scoped>
.container {
  padding: 32px 80px !important;
}
.container h3 {
  margin-top: 30px;
  margin-bottom: 20px;
  font-size: 40px;
  font-weight: 600;
  line-height: 1.75;
  text-align: center;
  color: #160f1d;
  min-height: 60px;
}

.container h4 {
  margin-bottom: 40px;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.75;
  text-align: center;
  color: cornflowerblue;
  min-height: 60px;
}

.container .title-section {
  font-size: 30px;
  margin: 20px 5px 20px 5px;
  font-weight: 600;
  line-height: 1.75;
  color: rgb(22, 33, 52);
  text-align: center;
}

.the-builder {
  margin: 75px 5px 10px 5px;
  font-size: 30px;
  font-weight: 600;
  line-height: 0.75;
  color: rgb(22, 33, 52);
  text-align: center;
}

.container .col-md-12 {
  padding-left: 0;
}
.page_about_us_info {
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  flex-wrap: wrap;
}

.page_about_us_info .value {
  background-color: #09041f;
  border-radius: 32px;
  min-height: 30vh;
  /* min-height: 25vh; */
  padding: 32px;
  text-align: center;
  width: 45%;
  margin-bottom: 16px;
}

.page_about_us_info .value__heading {
  margin-top: 16px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0px;
}

.page_about_us_info .value__content {
  margin-top: 16px;
}

.page_about_us_info .value__content .content {
  text-align: center;
}

.container .content {
  font-size: 14px;
  color: #fff;
  opacity: 0.8;
  line-height: 1.5;
}

.value__icon {
  display: flex;
  max-width: 100%;
  height: 100px;
  justify-content: center;
  align-items: center;
}

.value__icon img {
  width: 120px;
  max-height: 100px;
  -o-object-fit: contain;
  object-fit: contain;
  aspect-ratio: 4 / 3;
}

.builder-information p {
  margin: 35px 0px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.95;
  text-align: center;
  color: #160f1d;
}

.builder-img-features {
  min-height: 100px;
}

.builder-img-features img {
  width: 100%;
  height: 100px;
  max-width: 100px;
  -o-object-fit: contain;
  object-fit: contain;
  padding: 10px 5px;
  pointer-events: none;
  user-select: none;
}

@media (max-width: 992px) {
  .container {
    padding: 32px 25px !important;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 32px 25px !important;
  }
  .page_about_us_info {
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-wrap: wrap;
  }

  .page_about_us_info .value {
    background-color: #09041f;
    border-radius: 32px;
    min-height: 35vh;
    padding: 32px;
    text-align: center;
    width: 100%;
    margin-bottom: 25px;
  }

  .container .title-section {
    font-size: 30px;
    margin: 10px 5px 10px 5px;
    font-weight: 600;
    line-height: 0.75;
    color: rgb(22, 33, 52);
    text-align: center;
  }

  .the-builder {
    margin: 30px 5px 10px 5px;
    font-size: 30px;
    font-weight: 600;
    line-height: 1.35;
    color: rgb(22, 33, 52);
    text-align: center;
  }
}
</style>
